import { PropsWithChildren } from "react";
import { DesignationHatch } from "react-migration/domains/constraints/components/Hatch";

export type DesignationCategoryProps = {
  categoryId?: string;
  title: string;
  textClasses?: string;
  classes?: string;
};

export function DesignationCategory({
  title,
  categoryId,
  textClasses = "atlas-font-semibold",
  children,
  classes = "",
}: PropsWithChildren<DesignationCategoryProps>) {
  return (
    <span className={`atlas-flex atlas-items-start ${classes}`} data-testid="designationCategory">
      <div className="atlas-mr-2">
        <DesignationHatch id={categoryId} />
      </div>
      <span className={textClasses}>{title}</span>
      {children}
    </span>
  );
}
